

import React from 'react'
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useGetAllContentCreatorsQuery } from '../../reactWrapper/Redux/apiSlice';
import { toast } from 'react-toastify';

import Table from './Table';
import Pagination from '../Pagination/Pagination';
import { Link } from 'react-router-dom';


const ContentCreatorTable = () => {

  const siblingCount = 1;
  const pageColumn = 1;
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  const { data, isLoading } = useGetAllContentCreatorsQuery(page);


  const handlePageChange = useCallback(
    (page) => {
      setPage(page - 1);
    },
    []
  );

  const handleCopyLink = (link) => {
    if (!link) return;
    navigator.clipboard.writeText(link);
    toast.success('Referral link copied!');
  };

  const getInitials = (firstName, lastName) => {
    return `${firstName?.[0] || ''}${lastName?.[0] || ''}`.toUpperCase() || '?';
  };


  const tableHeader = useMemo(
    () => [
      {
        title: 'Creator',
        key: 'creator',
      },
      {
        title: 'Total Leads',
        key: 'conversion'
    
    },
      {
        title: 'Action',
        key: 'view',
      },
    ],
    []
  );

  const contentCreatorsList = data?.contentCreators?.data || [];

  const modifiedCreatorList = useMemo(() => {
    return contentCreatorsList.map((each) => [
      <div className='flex gap-[18px] items-center'>
        <div className='w-10 h-10 rounded-full  border  flex items-center justify-center
          text-white bg-brand-navy font-bold text-sm flex-shrink-0'>
          {getInitials(each?.first_name, each?.last_name)}
        </div>
        <div>
          <p className='font-medium text-gray-900'>{`${each?.first_name || ''} ${each?.last_name || ''}`.trim() || 'No Name'}</p>
          <p className='text-xs text-gray-500'>{each?.email}</p>

          
          <div className='flex items-center gap-2 max-w-[240px]'>
            <span className='truncate text-sm text-gray-600' title={each?.creator_link}>
              {each?.creator_link}
            </span>
            <button
              onClick={() => handleCopyLink(each?.creator_link)}
              className='p-1.5 rounded hover:bg-gray-100 text-gray-400 hover:text-gray-600 transition-colors'
              title='Copy Link'
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3" />
              </svg>
            </button>
          </div>
          
        </div>
      </div>,

      <h1 className="font-semibold">{each?.signups_count}</h1>,
      <Link to={`/content-creator/${each?.user_id}`}
        className="text-blue-500 underline">
        view
      </Link>
    ])
  }, [contentCreatorsList]);

  useEffect(() => {
    setTotalCount(data?.contentCreators?.total ?? 0);
    if (data?.contentCreators?.perPage) {
      setPageSize(data?.contentCreators?.perPage);
    }
  }, [data]);

  return (
    <div className='w-full space-y-4'>

      <Table
        header={tableHeader}
        label='List of Micro-Content Creators'
        column={modifiedCreatorList}
        isLoading={isLoading}
      />

      <section className="w-full">
        <Pagination
          rangeStart={
            totalCount !== 0
              ? (page || 0) * ((pageSize || 0) * pageColumn) + 1
              : 0
          }
          totalCount={totalCount}
          currentPage={(page || 0) + 1}
          pageSize={pageSize}
          pageColumn={pageColumn}
          siblingCount={siblingCount}
          onPageChange={handlePageChange}
          className="pt-9"
        />
      </section>
    </div>
  );
};


export default ContentCreatorTable;